<dex-lp-details-standalone
    [lp]="widgetImpl.$lp()"
    [tranches]="widgetImpl.$traches()"
    [isEmbedded]="false"
    [isCollapsed]="!!widgetImpl.$features().COLLAPSED"
    [isExpandCollapseEnabled]="!!widgetImpl.$features().SUPPORTS_EXPAND_COLLAPSE"
    [isSymbolClickable]="true"
    (toggleCollapsed)="handleToggleCollapsed()"
    (symbolClick)="handleSymbolClick($event)">
</dex-lp-details-standalone>
